import React from 'react';
import { SelectBox } from 'devextreme-react/select-box';
import Autosuggest from 'react-autosuggest';
import { renderSuggestion, shouldRenderSuggestions } from '../shared/constants';

const PickupDropoffCard = React.memo(function PickupDropoffCard({
  state,
  errors,
  inputPropsPickup,
  inputPropsDropoff,
  onPickupSuggestionsFetchRequested,
  onPickupSuggestionsClearRequested,
  getPickupSuggestionValue,
  onDropoffSuggestionsFetchRequested,
  onDropoffSuggestionsClearRequested,
  getDropoffSuggestionValue,
  onPickupToggleChange,
  onDropoffToggleChange,
  onPickupSuggestionSelected,
  onDropoffSuggestionSelected,
  onPickupZoneChange,
  onDropoffZoneChange,
}) {
  return (
    <div className="rx-card">
      <div className="rx-card-line rx-cl-teal" />
      <div className="rx-card-hd">
        <span className="rx-card-ico rx-ico-teal"><i className="fas fa-map-marker-alt" /></span>
        <span className="rx-card-title">Pick-up &amp; Drop Off</span>
      </div>
      <div className="rx-card-body">
        {/* Pick-up */}
        <div className="rx-loc-tag">
          <span className="rx-lt-dot rx-lt-dot-green" />
          <span className="rx-lt-label">Pick-up</span>
        </div>
        <div className="rx-tog-wrap">
          <label className="rx-tog">
            <input type="checkbox" checked={state.isPickupGoogleBooking} onChange={onPickupToggleChange} />
            <span className="rx-tog-sl" />
          </label>
          <span className="rx-tog-lbl">Google Address</span>
        </div>
        <div className="rx-cols-loc">
          <div className="rx-fg" style={{ marginBottom: 0 }}>
            <label>Location <span className="req">*</span></label>
            <Autosuggest
              name="pickupLocation"
              focusInputOnSuggestionClick={true}
              suggestions={state.pickupSuggestions}
              onSuggestionsFetchRequested={onPickupSuggestionsFetchRequested}
              onSuggestionsClearRequested={onPickupSuggestionsClearRequested}
              getSuggestionValue={getPickupSuggestionValue}
              onSuggestionSelected={onPickupSuggestionSelected}
              renderSuggestion={renderSuggestion}
              shouldRenderSuggestions={shouldRenderSuggestions}
              inputProps={inputPropsPickup}
              highlightFirstSuggestion={false}
            />
            {errors.pickupLocation.length > 0 && <span className="rx-err">{errors.pickupLocation}</span>}
          </div>
          <div className="rx-fg" style={{ marginBottom: 0 }}>
            <label>Zone <span className="req">*</span></label>
            <SelectBox
              dataSource={state.dropdownZone.length > 0 ? state.dropdownZone : []}
              placeholder="Select zone"
              name="pickupZoneId"
              defaultValue={0}
              value={state.pickupZoneId}
              displayExpr="name"
              valueExpr="id"
              onSelectionChanged={onPickupZoneChange}
              showClearButton={true}
              searchEnabled={true}
            />
            {errors.pickupZoneId.length > 0 && <span className="rx-err">{errors.pickupZoneId}</span>}
          </div>
        </div>

        <hr style={{ margin: '12px 0', borderColor: 'var(--rx-border)' }} />

        {/* Drop-off */}
        <div className="rx-loc-tag">
          <span className="rx-lt-dot rx-lt-dot-rose" />
          <span className="rx-lt-label">Drop Off</span>
        </div>
        <div className="rx-tog-wrap">
          <label className="rx-tog">
            <input type="checkbox" checked={state.isDropoffGoogleBooking} onChange={onDropoffToggleChange} />
            <span className="rx-tog-sl" />
          </label>
          <span className="rx-tog-lbl">Google Address</span>
        </div>
        <div className="rx-cols-loc">
          <div className="rx-fg" style={{ marginBottom: 0 }}>
            <label>Location <span className="req">*</span></label>
            <Autosuggest
              name="dropoffLocation"
              focusInputOnSuggestionClick={true}
              suggestions={state.dropoffSuggestions}
              onSuggestionsFetchRequested={onDropoffSuggestionsFetchRequested}
              onSuggestionsClearRequested={onDropoffSuggestionsClearRequested}
              getSuggestionValue={getDropoffSuggestionValue}
              onSuggestionSelected={onDropoffSuggestionSelected}
              renderSuggestion={renderSuggestion}
              shouldRenderSuggestions={shouldRenderSuggestions}
              inputProps={inputPropsDropoff}
              highlightFirstSuggestion={false}
            />
            {errors.dropoffLocation.length > 0 && <span className="rx-err">{errors.dropoffLocation}</span>}
          </div>
          <div className="rx-fg" style={{ marginBottom: 0 }}>
            <label>Zone <span className="req">*</span></label>
            <SelectBox
              dataSource={state.dropdownZone.length > 0 ? state.dropdownZone : []}
              placeholder="Select zone"
              name="dropoffZoneId"
              defaultValue={0}
              value={state.dropoffZoneId}
              displayExpr="name"
              valueExpr="id"
              onSelectionChanged={onDropoffZoneChange}
              showClearButton={true}
              searchEnabled={true}
            />
            {errors.dropoffZoneId.length > 0 && <span className="rx-err">{errors.dropoffZoneId}</span>}
          </div>
        </div>
      </div>
    </div>
  );
});

export default PickupDropoffCard;
